import { useState } from "react";
import { EyeFilledIcon, EyeOffFilledIcon } from "app/icons/navigation";

const ICON_SIZE = 20;

const useShowPassword = (defaultState, size = ICON_SIZE) => {
	const [showPassword, setShowPassword] = useState(defaultState || false);
	const icon = showPassword ? (
		<EyeOffFilledIcon
			data-testid="icon-visibility-off"
			className="icon-eye-off"
			height={size}
			width={size}
			onClick={() => setShowPassword(false)}
		/>
	) : (
		<EyeFilledIcon
			data-testid="icon-visibility"
			className="icon-eye"
			height={size}
			width={size}
			onClick={() => setShowPassword(true)}
		/>
	);
	return [icon, showPassword, setShowPassword];
};

export default useShowPassword;
